// components/layout/Header.jsx
import { Navigation } from './Navigation'

export function Header({ handleNavLinkClick }) {
  return (
    <header className="site-header">
      <Navigation onNavLinkClick={handleNavLinkClick} />
    </header>
  )
}